import React from 'react';
import styles from './Pagination.module.css'
import cx from "classnames";

type PaginationProps = {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    classes?: string;
};

const Pagination = ({totalPages, currentPage, onPageChange, classes}: PaginationProps) => {
    const generatePageNumbers = (totalPages: number) => {
        const pageNumbers = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1);
            for (let i = Math.max(currentPage - 1, 2); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    return (
        <div className={cx(styles['zr-pagination'], classes)}>
            <span
                className={cx(styles['zr-pagination-button'], styles['zr-pagination-arrow'], currentPage === 1 && styles['zr-disabled'] )}
                onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) {
                        onPageChange(currentPage - 1);
                    }
                }}
            >
                «
            </span>
            {generatePageNumbers(totalPages).map((page) => (
                <button
                    key={page}
                    className={cx(styles['zr-pagination-button'], currentPage === page && styles['zr-active'] )}
                    onClick={(e) => {
                        e.preventDefault();
                        onPageChange(page);
                    }}
                >
                    {page}
                </button>
            ))}
            <span
                className={cx(styles['zr-pagination-button'], styles['zr-pagination-arrow'], currentPage === totalPages && styles['zr-disabled'] )}
                onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages) {
                        onPageChange(currentPage + 1);
                    }
                }}
            >
                »
            </span>
        </div>
    );
};

export default Pagination;
